import actionHistory from '@ps/workbench/undo-redo/action-history'

const getInitState = () => {
  return {
    canUndo: false,
    canRedo: false,
    index: -1,
    length: 0,
    loading: false,
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },

    updateStatus(state) {
      state.canUndo = actionHistory.canUndo
      state.canRedo = actionHistory.canRedo
      state.index = actionHistory.index
      state.length = actionHistory.list.length
      // 不存储 action，避免 vuex 把数据污染了（不一定会，如果要查看数据的话，直接打印出来即可）
      // state.action = actionHistory.list.length > 0 ? actionHistory.list[actionHistory.index] : null
    },

    updateLoading(state, value) {
      state.loading = value
    },
  },

  actions: {
    /**
     * @param execute 正向操作
     * @param undo 反向操作
     * @param value
     * @param async 是否异步
     * @returns {ActionResponse}
     */
    async execute(
      { state, commit },
      { execute, undo, value, async, methodName },
    ) {
      let res
      const params = {
        execute,
        undo,
        // value 如果没有值的话传空对象
        value: value || {},
        async,
        methodName,
      }
      if (async) {
        // console.log('async execute')
        commit('updateLoading', true)
        res = await actionHistory.execute(params)
        commit('updateLoading', false)
      } else {
        // console.log('sync execute')
        res = actionHistory.execute(params)
      }
      // response 是 execute 操作的返回值，因为有些逆操作是强依赖正向操作的返回值的
      // 所以执行完正向操作后更新返回值，用在 undo 中使用
      actionHistory.updateTargetActionResponse(actionHistory.index, res)
      commit('updateStatus')
      return res
    },

    async undo({ state, commit }) {
      if (state.loading) {
        console.warn('无法执行 undo')
        return
      }

      const currentAction = actionHistory.list[state.index]
      let res
      if (currentAction.async) {
        // console.log('async undo')
        commit('updateLoading', true)
        res = await actionHistory.undo()
        commit('updateLoading', false)
      } else {
        // console.log('sync undo')
        res = actionHistory.undo()
      }
      commit('updateStatus')
      return res
    },

    async redo({ state, commit }) {
      if (state.loading) {
        console.warn('无法执行 redo')
        return
      }

      const currentAction = actionHistory.list[state.index + 1]
      let res
      if (currentAction.async) {
        // console.log('async redo')
        commit('updateLoading', true)
        res = await actionHistory.redo()
        commit('updateLoading', false)
      } else {
        // console.log('sync redo')
        res = actionHistory.redo()
      }
      actionHistory.updateTargetActionResponse(actionHistory.index, res)
      commit('updateStatus')
      return res
    },
  },
}
